import React from 'react';
import "../../assets/scss/components/form/header.scss"

const FormHeader = ({children, ...props}) => {
    return (
        <div className={`form-header ${props.className}`}>
            <div className="row">
                <div className="col-xs-9">
                    <h2 className="form-header-title d-flex align-items-center mb-0">
                        {props.icon && <span className="color-primary mr-1 d-flex align-items-center">
                    {props.icon}
                </span>}
                        {props.title}
                    </h2>
                    <p className="form-header-description">{props.description}</p>
                </div>
                <div className="col-xs-3">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default FormHeader;
